<template>
   <StudentProfile :profileDetails="profileDetails" :enrolledTutors="enrolledTutors"
      :previousEnrolledTutors="previousEnrolledTutors" />
</template>
<script setup>
import StudentProfile from "@/views/adminPublicProfile/studentProfile.vue";
import { defineProps } from "vue";

defineProps({
   profileDetails: null,
   enrolledTutors: null,
   previousEnrolledTutors: null
})

</script>
<style scoped></style>